// extracted by mini-css-extract-plugin
export var alternativeCareType = "styles-module--alternativeCareType--VrjEc";
export var imgContainer = "styles-module--imgContainer--1fl3l";
export var overallPadding = "styles-module--overallPadding--EXjtw";